module.exports = __webpack_public_path__ + "img/selected7-min.68e3b2d2.png";